export default __webpack_public_path__ + "static/media/downArrow.918a6a48.svg";